import React, { Component, Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { PARTICIPATION_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  ParticipationReportFieldEnum as Fields,
  ReportFieldEnum as ReportFields,
} from 'Common/FieldEnum';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';

class ParticipationReportFormContainer extends Component {
  reportOptions = [
    { value: 0, label: 'Daily' },
    { value: 1, label: 'by Attendance' },
    { value: 2, label: 'by Status' },
  ];

  feedingOptions = [
    { value: 0, label: 'Breakfast / Lunch / Other' },
    { value: 1, label: 'Supper' },
  ];

  getSummaryOnly = () => {
    if (this.props.formValues[Fields.ReportType] === 0) {
      return (
        <Field
          label={'Summary Only'}
          name={Fields.SummaryOnly}
          component={CheckboxField}
        />
      );
    }
  };

  getSpecialMSR = () => {
    if (this.props.formValues[Fields.FeedingType] === 0) {
      return (
        <Field
          label={'Include Special Milk & State Reimbursable'}
          name={Fields.IncludeSpecialMSR}
          component={CheckboxField}
        />
      );
    }
  };

  onChangeReportType = value => {
    if (value !== 0) {
      this.props.change(Fields.FeedingType, 0);
    }
  };

  render() {
    return (
      <Fragment>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column className="input-group--btn-group">
              <ReduxFormButtonGroup
                label={'Report Type'}
                options={this.reportOptions}
                formName={PARTICIPATION_REPORT_FORM_NAME}
                value={this.props.formValues[Fields.ReportType]}
                fieldName={Fields.ReportType}
                onChange={this.onChangeReportType}
              />
            </Grid.Column>
            <Grid.Column className="input-group--btn-group">
              <ReduxFormButtonGroup
                label={'Meal Type'}
                options={this.feedingOptions}
                formName={PARTICIPATION_REPORT_FORM_NAME}
                value={this.props.formValues[Fields.FeedingType]}
                fieldName={Fields.FeedingType}
                disabled={this.props.formValues[Fields.ReportType] !== 0}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={4}>
            <Grid.Column>
              <Field
                label={'From Date'}
                name={Fields.FromDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                label={'To Date'}
                name={Fields.ToDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid>
          <Grid.Row>
            <Grid.Column>{this.getSummaryOnly()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>{this.getSpecialMSR()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <ReportFormatButtonGroup
                formName={PARTICIPATION_REPORT_FORM_NAME}
                fieldName={ReportFields.ReportFormat}
                label={'Export Type'}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }

  if (
    !moment(values[Fields.ToDate]).isSame(values[Fields.FromDate]) &&
    values[Fields.FromDate]
  ) {
    if (!moment(values[Fields.ToDate]).isAfter(values[Fields.FromDate])) {
      errors[Fields.ToDate] = 'To Date must be equal or after From Date.';
    }
  }

  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(PARTICIPATION_REPORT_FORM_NAME)(state),
    validate,
  };
};

const ParticipationReportForm = reduxForm({
  form: PARTICIPATION_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps, {})(ParticipationReportFormContainer)));

export { ParticipationReportForm };



// WEBPACK FOOTER //
// ./src/pages/participation/components/ParticipationReportForm.js